import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuModule } from 'ngx-zcs-blocks';
import { AuthenticationService, GraphqlApiService } from 'ngx-core-services';
import { first } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { AppSyncEnv, DevEnvPreferenceService, RefreshService } from '../../services';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MenuModule,
  ],
  selector: 'customer-appsync-env-selector',
  templateUrl: './appsync-env-selector.component.html',
  styleUrls: ['./appsync-env-selector.component.scss'],
})
export class AppsyncEnvSelectorComponent {
  readonly gatewayList: AppSyncEnv[] = environment.aws.appsync.list;
  readonly envGateway$ = this.graphqlApiService.envGateway$;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly devEnvPreferenceService: DevEnvPreferenceService,
    private readonly graphqlApiService: GraphqlApiService,
    private readonly refreshService: RefreshService,
  ) {}

  async changeGateway(env: AppSyncEnv) {
    await this.graphqlApiService.build(env.region, env.url, env.desc);
    this.refreshService.refresh$.next();
    const user = await this.authenticationService.user$.pipe(first()).toPromise();
    if (!user?.uid) {
      return;
    }
    try {
      await this.devEnvPreferenceService.save(user.uid, env);
    } catch (error) {
      // Persistence is best-effort: requires Firestore rules for dev_settings/{uid}.
      // Env switch still applies for the current session.
      console.warn('dev-env-preference: failed to save', error);
    }
  }
}
